import { uploadData, getUrl } from 'aws-amplify/storage'
import awsconfig from '../../aws-exports'
import { schedulesServices } from '../../../database/schedules.database'

// Storage configurado automáticamente con Amplify v6

export const getImageStogeUrl = async (fileName) => {
    if (!fileName || fileName == '') {
        console.error('No se ha recibido el nombre del archivo')
        return
    }
    try {
        const result = await getUrl({ key: fileName, options: { accessLevel: 'guest' } })
        // getUrl().url puede ser instancia URL; RN <Image> requiere string en source.uri
        const url = result && result.url ? (typeof result.url === 'string' ? result.url : result.url.toString()) : null
        return url
    } catch (error) {
        console.error('Error al obtener la URL de la imagen:', error)
        return null
    }
}
/**
 * @description devuelvo la url que debe guardarse en la answer
 */
export const getUrlSave = async (filename, pickerResult_uri) => {
    console.log('1111111111111~ getUrlSave ~ filename:', filename, new Date())
    try {
        const response = await fetchWithTimeout(pickerResult_uri, 5000) // Fetch con timeout
        const blob = await response.blob()

        await uploadData({
            key: filename,
            data: blob,
            options: {
                contentType: 'image/jpeg',
            }
        }).result

        const imageUrl = await getImageStogeUrl(filename)
        const [imageUrlDB] = imageUrl.split('?')

        return {
            imageUrlDB,
            imageUrl,
        }
    } catch (error) {
        console.error('getUrlSave - Error:', error)

        // Guardar en tabla de imágenes pendientes
        await handleFailedUpload(filename, pickerResult_uri)
        return null
    }
}

export const uploadImage = async (filename, pickerResult_uri) => {
    console.log('22222222222222~ uploadImage ~ filename:', filename, new Date())
    try {
        if (!filename || filename === '') throw new Error('uploadImage - No se ha recibido el nombre del archivo')
        if (!pickerResult_uri || pickerResult_uri === '') throw new Error('uploadImage - No se ha recibido la uri de la imagen')
        console.log('uploadImage - filename:', new Date())
        const response = await fetchWithTimeout(pickerResult_uri, 3000) // Fetch con timeout
        console.log('uploadImage - filename: ~ response:', new Date())
        const blob = await response.blob()

        let send = await uploadData({
            key: filename,
            data: blob,
            options: {
                contentType: 'image/jpeg',
            }
        }).result

        console.log('uploadImage - Imagen subida correctamente', send)
        return true
    } catch (error) {
        console.error('uploadImage - Error:', error)
        // Guardar en tabla de imágenes pendientes
        await handleFailedUpload(filename, pickerResult_uri)
        return false
    }
}

const fetchWithTimeout = async (uri, timeout = 5000) => {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error('Timeout al obtener la imagen')), timeout)

        fetch(uri)
            .then((response) => {
                clearTimeout(timer)
                resolve(response)
            })
            .catch((error) => {
                clearTimeout(timer)
                reject(error)
            })
    })
}
const handleFailedUpload = async (filename, pickerResult_uri) => {
    try {
        const result = await schedulesServices.savePendingImage(filename, pickerResult_uri)
        if (result) {
            console.log(`Imagen guardada en la tabla de pendientes: ${filename}`)
        } else {
            console.log(`La imagen ya estaba en la tabla de pendientes: ${filename}`)
        }
    } catch (error) {
        console.error('Error al manejar el guardado en tabla de pendientes:', error)
    }
}
